import { Assert } from '@cotera/utilities';
import { createContext, useContext } from 'react';
import { ToolCallModel } from './tool-call.model';

export const ColumnModelContext = createContext<ToolCallModel | null>(null);

export const useColumnModel = () => {
  const model = useContext(ColumnModelContext);
  Assert.assert(model !== null, 'Column model not found');
  return model;
};
